import clsx from 'clsx'

export function workProductCardClassName(active: boolean) {
  return clsx(
    'grid grid-cols-[60px_minmax(0,1fr)] items-center min-h-[62px] w-full max-w-[420px] rounded-[5px] overflow-hidden border',
    active
      ? 'cursor-default bg-surface-selected-subtle border-brand-neutral-400'
      : 'group bg-surface-content border-border-strong hover-capable:hover:bg-surface-hover'
  )
}
